'use client'

import { Layout } from '@/components/Layout'
import { Footer, Header } from '@/components/home'
import { useAuth } from '@/contexts/AuthContext'
import type { PropsWithChildren } from 'react'

type PrivacyPolicyLayoutProps = {}

export default function PrivacyPolicyLayout({ children }: PropsWithChildren<PrivacyPolicyLayoutProps>) {
  const { currentUser, isLoading } = useAuth()

  // If user is authenticated, use the standard Layout with sidebar
  if (currentUser) {
    return <Layout title='Privacy Policy'>{children}</Layout>
  }

  // If still loading, show minimal layout to prevent flicker
  if (isLoading) {
    return <div className='min-h-screen'>{children}</div>
  }

  // For non-authenticated users, show public layout with header and footer
  return (
    <div className='min-h-screen flex flex-col'>
      <Header />
      <main className='flex-1 lp-container'>{children}</main>
      <Footer />
    </div>
  )
}
